// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kAj5","delete":"styles_delete__10ETJ","update":"styles_update__mBhCB","add":"styles_add__2uyGi"};